import { render, staticRenderFns } from "./cobranzas.vue?vue&type=template&id=1e246ff2"
import script from "./cobranzas.vue?vue&type=script&lang=js"
export * from "./cobranzas.vue?vue&type=script&lang=js"
import style0 from "./cobranzas.vue?vue&type=style&index=0&id=1e246ff2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports